<div>
    <div *ngIf="(resFromParticipationCall?.status?.toLowerCase() == 'pending') || hideRequest" class="alert alert-warning" role="alert">
        {{'WEBKESS_INTEGRATION.ACTIVATION_STILL_IN_PROGRESS' | translate}}
    </div>
    <!--<div class="container-fluid">-->
    <div class="px-4">
        <form [formGroup]="myGroup" #ngForm="ngForm">

            <!-- Connect to webKess starts -->
            <h5 class="section-head my-4">{{'WEBKESS_INTEGRATION.WEBKESS.CONNECT_TO' | translate}}</h5>
            <div class="no-padding col-md-12 col-sm-12">
                <div class="col-sm-12 col-md12 p-0 form-group">
                    <label class="title-label" for="activateWebKess">
                        <div class="section-title">{{'WEBKESS_INTEGRATION.WEBKESS.PARTICIPATION' | translate }}</div>
                        {{'WEBKESS_INTEGRATION.DESCRIPTION' | translate }}
                    </label>
                    <label class="title-label" *ngIf="institutionData?.institution.institution.isGroup != 1 && 
                        (institutionData?.institution.institution.countryID==3 || institutionData?.institution.institution.countryID==219 || 
                        institutionData?.institution.institution.countryID==15) && (institutionData?.institution.institution.institutionName != '' 
                        && institutionData?.institution.institution.institutionName != null) && 
                        (resFromParticipationCall?.status==null || (resFromParticipationCall?.status?.toLowerCase() !='enabled' && 
                        resFromParticipationCall?.status?.toLowerCase() != 'pending'))" class="section-title mb-4 mt-2 d-block">
                            <br>{{'WEBKESS_INTEGRATION.WEBKESS.DISABLED_MESSAGE' | translate}}
                        </label>
                    <div class="col-auto">
                    </div>
                </div>
            </div>
            <!-- Connect to webKess ends -->
            <br>
            <!-- webKess enabled options start -->
            <h5 class="section-head my-4" *ngIf="myGroup.get('activateWebKess').value">
                {{'WEBKESS_INTEGRATION.WEBKESS.ENABLED_INTERFACE' | translate}}</h5>
            <div *ngIf="myGroup.get('activateWebKess').value" class="d-flex">
              <div class="no-padding col-md-4 col-sm-12 mr-2" *ngIf="isObserveLicense(institutionData?.institution.institution.packageID)">
                  <div class="col-sm-12 col-md-12 p-0 form-group">
                      <label class="title-label" for="Observation">
                        <div class="section-title">{{'WEBKESS_INTEGRATION.SHARE_OBSERVATION_DATA' | translate }}</div>
                        {{'WEBKESS_INTEGRATION.ASH_COMPLIANCE' | translate }}
                      </label>
                      <div class="col-auto">
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && resFromParticipationCall?.status==null" color="primary" name="Observation" formControlName="activateObservation" disabled>
                        </mat-slide-toggle> 
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && ((resFromParticipationCall?.status?.toLowerCase()=='pending') || hideRequest)" color="primary" name="Observation" formControlName="activateObservation" disabled>   
                        </mat-slide-toggle> 
                        <label *ngIf="(config.userData.roleName.roleId==1 || config.userData.roleName.roleId==2 || config.userData.roleName.roleId==3)" class="section-title mb-4 mt-2 d-block">
                          {{((resFromParticipationCall.activateObservation) ? translationKeys.Button.Yes : translationKeys.Button.No) | translate}}
                        </label>
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && resFromParticipationCall?.status?.toLowerCase() =='enabled'"  color="primary" name="Observation" formControlName="activateObservation">
                        </mat-slide-toggle> 
                      </div>
                  </div>
              </div>
              <div class="no-padding col-md-6 col-sm-12 ">
                  <div class="col-sm-12 col-md-12 p-0 form-group">
                      <label class="title-label" for="Consumption">
                        <div class="section-title">{{'WEBKESS_INTEGRATION.SHARE_HAND_KISS_CONSUMPTION' | translate }}</div>
                        {{'WEBKESS_INTEGRATION.HAND_KISS_CONSUMPTION' | translate }}
                      </label>
                      <div class="col-auto">
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && resFromParticipationCall?.status==null"  disabled color="primary" name="Consumption" formControlName="activateConsumption">  
                        </mat-slide-toggle> 
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && ((resFromParticipationCall?.status?.toLowerCase()=='pending') || hideRequest)" color="primary" name="Consumption" formControlName="activateConsumption" disabled>
                        </mat-slide-toggle>
                        <label *ngIf="(config.userData.roleName.roleId == 1 || config.userData.roleName.roleId == 2 || config.userData.roleName.roleId == 3 ) " class="section-title mb-4 mt-2 d-block">
                          {{((resFromParticipationCall.activateConsumption) ? translationKeys.Button.Yes : translationKeys.Button.No) | translate}}
                        </label>
                        <mat-slide-toggle *ngIf="config.userData.roleName.roleId == 4 && resFromParticipationCall?.status?.toLowerCase()=='enabled'" color="primary" name="Consumption" formControlName="activateConsumption">
                              
                        </mat-slide-toggle>
                      </div>
                  </div>
              </div>
            </div>
        </form>
        <!-- webKess enabled options end -->
        <div class="col-md-12 col-sm-12">
            <button *ngIf="config.userData.roleName.roleId == 4 && resFromParticipationCall?.status==null && myGroup.get('activateWebKess').value && !hideRequest" (click)="onClickSaveParticipation($event)" class="btn-continue-bordered-bd mr-4 align-button">{{ 'WEBKESS_INTEGRATION.REQUEST' |
        translate }}</button>
            <button *ngIf=" config.userData.roleName.roleId == 4 && resFromParticipationCall?.status=='Enabled' && !hideRequest &&
         (myGroup.get('activateObservation').value!== resFromParticipationCall?.activateObservation ||
         myGroup.get('activateConsumption').value!== resFromParticipationCall?.activateConsumption)" (click)="onClickSaveParticipation($event)" class="btn-continue-bordered-bd mr-4 align-button">{{ 'Update request' | translate
        }}</button>
        </div>


        <form [formGroup]="settingsGroup" #ngForm2="ngForm">


            <!-- webKess settings start -->
            <h5 class="section-head my-4" *ngIf="(resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 &&  myGroup.get('activateWebKess').value) || (resFromParticipationCall?.status?.toLowerCase()=='pending' && khCodeCheck)">
                {{'WEBKESS_INTEGRATION.WEBKESS.SETTINGS' | translate}}</h5>
            <div class="">
                <div class="row">
                    <div class="col-md-4 col-sm-12" *ngIf="(resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 && myGroup.get('activateWebKess').value) || (resFromParticipationCall?.status?.toLowerCase()=='pending' && khCodeCheck)">
                        <div class="col-sm-12 col-md-12 p-0 form-group">
                            
                          <mat-form-field class="w-100">
                            <mat-label>{{'WEBKESS_INTEGRATION.HOSPITAL_SHORT_NAME' | translate }}</mat-label>
                            <input matInput inputSanitizer type="text" name="KHCode" formControlName="KHCode" [ngClass]="{'is-invalid':settingsGroup.get('KHCode').errors && ( submitted  )}" autocomplete="one-time-code">
                          </mat-form-field>
                          
                         
                            <div class="col-auto">
                                <!-- <input class="form-control" type="text" name="KHCode" [ngClass]="{'is-invalid':settingsGroup.get('KHCode').errors && ( submitted  )}" formControlName="KHCode"> -->

                                <div class="invalid-feedback" *ngIf="settingsGroup.get('KHCode').errors && ( submitted )">
                                    <span *ngIf="settingsGroup.get('KHCode').errors.required">
                                  {{'WEBKESS_INTEGRATION.HOSPITAL_SHORT_NAME_REQUIRED' | translate }}
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12" *ngIf="(resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 && myGroup.get('activateWebKess').value) || (resFromParticipationCall?.status?.toLowerCase()=='pending' && khCodeCheck)">
                        <div class="col-sm-12 col-md-12 p-0 form-group ">

                          <mat-form-field class="w-100">
                            <mat-label>{{'WEBKESS_INTEGRATION.USERNAME' | translate }}</mat-label>
                            <input matInput inputSanitizer type="text" name="CHCUsername" formControlName="CHCUsername" [ngClass]="{'is-invalid':settingsGroup.get('CHCUsername').errors && ( submitted)}" autocomplete="one-time-code">
                          </mat-form-field>

                         
                            <div class="col-auto">
                               <div class="invalid-feedback" *ngIf="settingsGroup.get('CHCUsername').errors && ( submitted)">
                                    <span *ngIf="settingsGroup.get('CHCUsername').errors.required">
                    {{'WEBKESS_INTEGRATION.USERNAME_REQUIRED' | translate }}
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12" *ngIf="(resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 && myGroup.get('activateWebKess').value) || (resFromParticipationCall?.status?.toLowerCase()=='pending' && khCodeCheck)">
                        <div class="col-sm-12 col-md-12 p-0 form-group ">

                          <mat-form-field class="w-100">
                            <mat-label>{{'WEBKESS_INTEGRATION.PASSWORD' | translate }}</mat-label>
                            <input matInput inputSanitizer type="password" name="CHCPassword" formControlName="CHCPassword" [ngClass]="{'is-invalid':settingsGroup.get('CHCPassword').errors && ( submitted)}" autocomplete="one-time-code">
                          </mat-form-field>
 
                            <div class="col-auto"> 
                                <div class="invalid-feedback" *ngIf="settingsGroup.get('CHCPassword').errors && (  submitted)">
                                    <span *ngIf="settingsGroup.get('CHCPassword').errors.required">
                    {{'WEBKESS_INTEGRATION.PASSWORD_REQUIRED' | translate }}
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- webKess settings end -->
        </form> 

        <div class="no-padding d-flex justify-content-end col-md-12 col-sm-12" *ngIf="resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 && myGroup.get('activateWebKess').value && !khCodeCheck ">
            <button (click)="onClickSaveSettings($event)" class="btn-continue-bordered-bd align-button">{{ 'WEBKESS_INTEGRATION.CONNECT' |
        translate }}</button>
        </div>

        <div class="no-padding  d-flex justify-content-end col-md-12 col-sm-12" *ngIf="(resFromParticipationCall?.status?.toLowerCase()=='enabled' && config.userData.roleName.roleId == 4 && myGroup.get('activateWebKess').value && khCodeCheck) ||
      (resFromParticipationCall?.status?.toLowerCase()=='pending' && khCodeCheck) ">
            <button (click)="onClickSaveSettings($event)" class="btn-continue-bordered-bd align-button">{{ 'WEBKESS_INTEGRATION.RECONNECT' |
        translate }}</button>
        </div>

    </div>
</div>